import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-header',
    templateUrl: './modal-header.component.html',
    standalone: false
})
export class ModalHeaderComponent {

}
